export async function getCurrentUser() {
  const url = `${import.meta.env.VITE_TOOLKIT_URL}/current_user`
  const headers = new Headers({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  })
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers
  })
  const responseJSON = await response.json()
  if (response.status >= 200 && response.status < 300) {
    return responseJSON
  }
  throw {
    statusCode: response.status,
    responseJSON: responseJSON
  }
}

export async function getAbsorbSAMLResponse() {
  const url = `${import.meta.env.VITE_AUTH_URL}/samlresponse/absorb`
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include'
  })
  const responseText = await response.text()
  if (response.status >= 200 && response.status < 300) {
    return responseText
  }
  throw {
    statusCode: response.status,
    responseText: responseText
  }
}

export function postSAMLResponseForm(samlResponse) {
  var form = document.createElement('form')
  var samlResponseElement = document.createElement('input')
  form.method = 'POST'
  form.action = `${import.meta.env.VITE_LMS_URL}/api/Rest/v2/authentication/saml`
  form.target = '_blank'
  samlResponseElement.type = 'hidden'
  samlResponseElement.value = samlResponse
  samlResponseElement.name = 'samlresponse'
  form.appendChild(samlResponseElement)
  document.body.appendChild(form)
  form.submit()
  form.remove()
}

export async function sendToLMS() {
  var samlResponse = await getAbsorbSAMLResponse()
  postSAMLResponseForm(samlResponse)
}

